module.exports = __webpack_public_path__ + "static/media/profile-placeholder.4bae7860.png";